// @flow

import { rem } from 'polished';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import QRCode from 'react-qr-code';
import styled from 'styled-components';
import { Licenses } from 'types/common';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
import { Button, Push, StoreBadge } from '..';
import imagePictureMobile from '../../../assets/images/picto_parcour_parier.png';
import imagePictureDesktop from '../../../assets/images/picto_parcour_poker.png';
import config from '../../../config/app.config';
import { getAppleStorePath, getGooglePlayPath, RedirectServices, getRedirectUrl } from '../../../config/paths';
import { BasePath } from '../../../config/paths';
import { __ } from '../../../i18n/l10n';
import { isIOS, isAndroid } from '../../../lib/useragent';
import { colorPalette, sizes } from '../../../styles/GlobalStyle';

type GroupPushRawProps = {
  className?: string,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const Container = styled.div`
  width: 100%;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const StyledPush = styled(Push)`
  margin-bottom: 10px;
  height: inherit;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const PlayButton = styled(Button)`
  font-size: ${rem('22px')};
  height: 90px;
  margin-bottom: 20px;

  .inner {
    justify-content: center;
  }

  &:after {
    content: '';
    position: absolute;
    left: calc(50% - 20px);
    bottom: -19px;
    border-top: 20px solid ${colorPalette.primary.active};
    border-right: 20px solid transparent;
    border-left: 20px solid transparent;

    transition: 300ms all ease-out;
  }

  &:hover {
    &:after {
      border-top-color: ${colorPalette.primary.hover};
    }
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const PlayText = styled.div`
  text-transform: uppercase;
  text-align: center;
  font-size: ${rem('20px')};
  font-weight: 900;
  letter-spacing: 0.6px;
  margin-top: ${sizes.padding};
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const ArrowDown = styled.div`
  margin: 10px auto;
  width: 20px;
  border-top: 20px solid ${colorPalette.primary.active};
  border-right: 20px solid transparent;
  border-left: 20px solid transparent;

  &:after {
    content: '';
    position: absolute;
    margin-top: -18px;
    margin-left: -16px;
    border-top: 16px solid ${colorPalette.primary.foreGround};
    border-right: 16px solid transparent;
    border-left: 16px solid transparent;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const StoreBadges = styled.div`
  display: flex;
  justify-content: center;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Used in JSX below
const QRContainer = styled.div`
  text-align: center;
  margin: ${sizes.padding};
`;

export const GroupPush = ({ className }: GroupPushRawProps) => {
  const handleClickPlayApp = () => {
    const anchor = document.createElement('a');
    if (isIOS) {
      anchor.href = getAppleStorePath(config.license);
    } else if (isAndroid) {
      anchor.href = getGooglePlayPath();
    } else {
      anchor.href = '';
    }
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    anchor.click();
  };

  return (
    <>
      <Container className={`${className || ''} groupPush`}>
        <StyledPush
          title={__('Bet on sports')}
          subtitle={__('The best odds are your odds')}
          visual={imagePictureMobile}
          url={getRedirectUrl(RedirectServices.PLAY_BETTING)}
        />
        {config.license !== Licenses.DE && (
          <StyledPush
            title={__('Play poker')}
            subtitle={__('Come and take a seat')}
            visual={imagePictureDesktop}
            url={getRedirectUrl(RedirectServices.PLAY_POKER)}
          />
        )}
      </Container>
      {(isIOS || isAndroid) && !config.isEmbedded && (
        <>
          <PlayButton
            type={'submit'}
            theme={'primary'}
            onClick={handleClickPlayApp}
          >
            {__('Play on the app !')}
          </PlayButton>

          <StoreBadges>
            {!isAndroid && (
              <a
                href={getAppleStorePath(config.license)}
                target={'_blank'}
                rel={'noopener noreferrer'}
              >
                <StoreBadge name={`apple-store-${config.license.toLowerCase()}`} />
              </a>
            )}
            {!isIOS && (
              <a
                href={getGooglePlayPath()}
                target={'_blank'}
                rel={'noopener noreferrer'}
              >
                <StoreBadge name={`google-play-${config.license.toLowerCase()}`} />
              </a>
            )}
          </StoreBadges>
        </>
      )}
      {!isIOS && !isAndroid && (
        <>
          <PlayText>{__('Play on the app !')}</PlayText>
          <ArrowDown />
          <StoreBadges>
            <StoreBadge name={`apple-store-${config.license.toLowerCase()}`} />
            <StoreBadge name={`google-play-${config.license.toLowerCase()}`} />
          </StoreBadges>
          <QRContainer>
            <QRCode
              value={`${window.location.origin}${BasePath}/redirect/store`}
              bgColor={'#000000'}
              fgColor={'#FFFFFF'}
              size={150}
            />
          </QRContainer>
        </>
      )}
    </>
  );
};
